import { createSelector } from "reselect";

const getIds = (state) => state.artists.data;
const getArtists = (state) => state.entities.artists;

/*****************
 *
 * EXPORT METHODS
 *
 *****************/

export const getArtistsList = (state) =>
    createSelector(getIds, getArtists, (ids, artists) => {
        return ids
            .map((id) => {
                return artists[id];
            })
            .sort((a, b) => a.name.localeCompare(b.name));
    })(state);

export const getArtistDetails = (state, id) =>
    createSelector(getArtists, (artists) => {
        if (!artists[id]) return null;

        return artists[id];
    })(state);
